import React,{useEffect, useState} from 'react'
import TableHeading from '../../Components/common/table/Tableheading'
import  showDataWithPost  from '../../Utils/APIs/commonShowWithPost'

const Payment = () => {
  const [consignmentApprovedByAdminList, setConsignmentApprovedByAdminList] = useState([]);
  const [paymentResponse, setPaymentResponse] = useState(false);
  useEffect(() => {
    const getConsignmentApprovedByAdminList = async()  => {
      const response = await showDataWithPost('track/consignmentApprovedByAdminList', {});
      if(response.success){
        setConsignmentApprovedByAdminList(response.data);
      }else setConsignmentApprovedByAdminList([]);

    }
    getConsignmentApprovedByAdminList();
    setPaymentResponse(false);
  }, [paymentResponse]);
  const handlePayment =async (id) => {
    alert('Payment Initiated',id);
    // Add your payment logic here
    const response = await showDataWithPost('track/consignmentPaymentApprovedByAccount', {id});
    if(response?.success){
      setPaymentResponse(true);
    }else{
      response?.message &&  alert(response?.message);
    }
  }
  return (
    <div className="w-auto flex flex-col">
        <div className="mainHeading">
          <h1 className='text-3xl font-semibold tracking-widest text-center p-2 bg-gray-50  rounded-lg'>T<span className='text-lg'>RANSPORT</span> P<span className='text-lg'>AYMENT</span> S<span className='text-lg'>YSTEM</span></h1>
        </div>
        <table className="w-full mt-10 text-center">
          <TableHeading 
            list={['Sr. no.','Vehicle Number', 'Driver Name', 'Driver Contact', 'Amount', 'Action']}
          />
          <tbody>
          {
            consignmentApprovedByAdminList && consignmentApprovedByAdminList.length > 0 ? (
              consignmentApprovedByAdminList.map((item, index) => (
                <tr key={index} className="bg-white border-b">
                  <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900">{index + 1}</td>
                  <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900">{item?.vehicleData?.[0]?.vehicleNumber}</td>
                  <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900">{item?.vehicleData?.[0]?.driverName}</td>
                  <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900">{item?.vehicleData?.[0]?.driverContact}</td>
                  <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900">{item.totalAmount}</td>
                  <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900">
                    <button 
                      className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                      onClick={()=> handlePayment(item._id) }>
                      Pay
                    </button>
                  </td>
                </tr>
              ) )

            ) : (<tr className="bg-white border-b">
                  <td colSpan={9} className="text-center px-6 py-4">
                    No data available
                  </td>
                </tr>
              )
          }
          </tbody>
        </table>
    </div>
  )
}

export default Payment